import { emailAccounts } from '@markku/db'
import { createInsertSchema, createSelectSchema } from 'drizzle-zod'
import { z } from 'zod'

export const selectEmailAccountSchema = createSelectSchema(emailAccounts)

export const insertEmailAccountSchema = createInsertSchema(emailAccounts).omit({
  id: true,
  createdAt: true,
  updatedAt: true,
})

export const updateEmailAccountSchema = insertEmailAccountSchema.partial()

export type EmailAccount = z.infer<typeof selectEmailAccountSchema>
export type CreateEmailAccount = z.infer<typeof insertEmailAccountSchema>
export type UpdateEmailAccount = z.infer<typeof updateEmailAccountSchema>
